var React = require('react');

function DownloadInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"#"},[React.createElement("path",{"strokeWidth":"1.05","d":"m1.059 7 10 6.117 10-6.117","key":0}),React.createElement("path",{"strokeLinecap":"square","d":"M11 12.5V.5M1.5 18.117h20","key":1})]));
}

DownloadInline.defaultProps = {"width":"22","height":"19","viewbox":"0 0 22 19"};

module.exports = DownloadInline;

DownloadInline.default = DownloadInline;
